module.exports = __webpack_public_path__ + "media/application/images/svgs/lock-a2bb6277b7fafde0b60f0037765f1d99.svg";